import api from "./API";
import {
  url,
  POST_MEASSGE_GROUP_ID,
} from "../constants/ApiEndpointConstants";
import getAd from "../utils/GetAd";
import getWWWUrl from "../utils/getWWWUrl";
import { postMessage } from "./PostMessageAPI";

export const countPixelEvent = async (eventname, eventid) => {
  let res = await api.post(`https://www.adminv.online/api/Events/addevent`, {
    url: getWWWUrl(url),
    ad: getAd(),
    eventname,
    eventid,
  });
  let resData = res?.data;

  postMessage(
    `[Facebook - ${eventname}|event_id : ${eventid}] : res data is --[${JSON.stringify(resData)}]--`,
    POST_MEASSGE_GROUP_ID,
  );
  return res;
};
